module.exports = __webpack_public_path__ + "media/images/icon-https-73abd86624ca4c09a380e14d5f60e258.svg";